import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Komponen ini akan otomatis mendeteksi perubahan halaman (pathname)
 * dan memaksa window untuk scroll kembali ke paling atas.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll ke (0, 0)
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant', // Gunakan 'instant' agar tidak terlihat aneh
    });
  }, [pathname]); // <-- Efek ini akan berjalan SETIAP KALI 'pathname' berubah

  return null; // Komponen ini tidak me-render UI apapun
}